module.exports = __webpack_public_path__ + "static/media/location-icon.440437e3.svg";